export default {
  title: {
    regular: 'Reguliere opties voor producten',
    meal: 'Maak uw meal deal-item aan',
    upsell: 'Maak uw upsellgroep aan',
  },
  description: {
    regular:
      'Selecteer opties die worden opgenomen in de nieuwe optiegroep als ze al in een andere optiegroep bestaan. U kunt ook doorgaan met het aanmaken van de optiegroep en later nieuwe opties toevoegen.',
    meal: 'Selecteer producten die worden opgenomen in uw meal deal-item. Als producten nog niet bestaan, maak ze aan op de pagina "Menu\'s beheren". Zorg ervoor dat het meal deal-item wordt gekoppeld aan de juiste producten in de sectie "Opties" van de productbouwer.',
    upsell:
      'Selecteer producten die worden opgenomen in uw upsellgroep. Als producten nog niet bestaan, maak ze aan op de pagina "Menu\'s beheren". Zorg ervoor dat het upsell-item wordt gekoppeld aan de juiste producten in de sectie "Opties" van de productbouwer.',
  },
  fields: {
    name: {
      label: 'Naam',
      placeholder: 'Voer naam van optiegroep in',
    },
    max_quantity: {
      label: 'Max. aantal',
      placeholder: 'Max. aantal opties',
    },
    is_required: {
      label: 'Verplicht',
    },
  },
  labels: {
    visible: 'Zichtbaar',
    hidden: 'Verborgen',
    multiply: 'Vermenigvuldigbaar',
  },
  buttons: {
    save: 'Opslaan',
    close: 'Sluiten',
  },
  toasts: {
    modifier_group_got_created: 'Optiegroep is aangemaakt',
    modifier_group_got_updated: 'Optiegroep is bijgewerkt',
  },
};
